/**
 * @extends com.inq.events.EventDispatcher
 * @constructor
 */
window.Application = function() {
	this.constructor.__super__.call(this);
	Application.application = this;
    com.inq.utils.ConsoleLogger.redirectTraces();
	this.initializeParameters();
	this.applicationController = new com.inq.flash.client.control.CMSDKAppController();
	com.inq.flash.client.chatskins.CoBrowseMgr.init();
	this.applicationController.registerMessageHandlers();
	this.preventChatClose = false;
};
$hxClasses.extend(com.inq.events.EventDispatcher, Application, "Application");
Application.main = function() {
	com.inq.flash.client.control.PersistenceManager.reopen();
	Application.application = null;
	com.inq.flash.client.control.ApplicationController.cleanUp();
	var app = new Application();

	com.inq.utils.Util.publish("Application",Application);
	com.inq.utils.Util.publish("Application.application",Application.application);
	com.inq.utils.Util.publish("Application.application.engage", $bind(Application.application, Application.application.engageChat));
	com.inq.utils.Util.publish("Application.application.getMessages", $bind(Application.application, Application.application.getChatMessages));
	com.inq.utils.Util.publish("Application.application.close", $bind(Application.application, Application.application.close));
	com.inq.utils.Util.publish("Application.application.closeEngagement", $bind(Application.application, Application.application.closeChat));
	com.inq.utils.Util.publish("Application.application.sendMessage", $bind(Application.application, Application.application.sendMessage));
	com.inq.utils.Util.publish("Application.application.sendChatActivity", $bind(Application.application, Application.application.sendChatActivity));
	com.inq.utils.Util.publish("Application.application.requestTranscript", $bind(Application.application, Application.application.requestTranscript));
	com.inq.utils.Util.publish("Application.application.chatUIRendered", $bind(Application.application, Application.application.chatUIRendered));
	com.inq.utils.Util.publish("Application.application.isChatInProgress", $bind(Application.application, Application.prototype.isInProgress));
	com.inq.utils.Util.publish("Application.application.sendVALinkClicked", $bind(Application.application, Application.prototype.sendVALinkClicked));
	com.inq.utils.Util.publish("Application.application.sendVAMessage", $bind(Application.application, Application.prototype.sendVAMessage));
	com.inq.utils.Util.publish("Application.application.getOpeners", $bind(Application.application, Application.prototype.getOpeners));
	com.inq.utils.Util.publish("Application.application.checkActiveConversation", $bind(Application.application, Application.prototype.isConversationActive));
	com.inq.utils.Util.publish("Application.application.setCustomerName", $bind(Application.application, Application.prototype.setCustomerName));
	com.inq.utils.Util.publish("Application.application.getCustomerName", $bind(Application.application, Application.prototype.getCustomerName));
	com.inq.utils.Util.publish("Application.application.sendRichContentMessage", $bind(Application.application, Application.prototype.sendRichContentResponse));
	com.inq.utils.Util.publish("Application.application.isConnected", $bind(Application.application, Application.prototype.isConnected));
	com.inq.utils.Util.publish("Application.application.isAsyncChat", $bind(Application.application, Application.prototype.isAsyncChat));
	com.inq.utils.Util.publish("Application.application.getAsyncChatMode", $bind(Application.application, Application.prototype.getAsyncChatMode));
	com.inq.utils.Util.publish("Application.application.getPersistenceManager", $bind(Application.application, Application.prototype.getPersistenceManager));
	com.inq.utils.Util.publish("Application.application.getImagePath", $bind(Application.application, Application.prototype.getImagePath));
	com.inq.utils.Util.publish("Application.application.isMinimized", $bind(Application.application, Application.prototype.isMinimized));
	com.inq.utils.Util.publish("Application.application.getMinimizedCount", $bind(Application.application, Application.prototype.getMinimizedCount));
	com.inq.utils.Util.publish("Application.application.resetMinimizedCount", $bind(Application.application, Application.prototype.resetMinimizedCount));
	com.inq.utils.Util.publish("Application.application.isChatQueued", $bind(Application.application, Application.prototype.isChatQueued));
	com.inq.utils.Util.publish("Application.application.isPersistentWindow", $bind(Application.application, Application.prototype.isPersistentWindow));
	com.inq.utils.Util.publish("Application.application.getDeviceType", $bind(Application.application, Application.prototype.getDeviceType));
	com.inq.utils.Util.publish("Application.application.getChatParams", $bind(Application.application, Application.prototype.getChatParams));
	com.inq.utils.Util.publish("Application.application.getPersistedValue", $bind(Application.application, Application.prototype.getPersistedValue));
    com.inq.utils.Util.publish("Application.application.setPersistedValue", $bind(Application.application, Application.prototype.setPersistedValue));
    com.inq.utils.Util.publish("Application.application.setPersistedValues", $bind(Application.application, Application.prototype.setPersistedValues));
	com.inq.utils.Util.publish("Application.application.setAsyncLoading", $bind(Application.application, Application.prototype.setAsyncLoading));
    com.inq.utils.Util.publish("Application.application.showOpenerForEndedConv", $bind(Application.application, Application.prototype.showOpenerForEndedConv));
    com.inq.utils.Util.publish("Application.application.sendSystemMessage", $bind(Application.application, Application.prototype.sendSystemMessage));
    com.inq.utils.Util.publish("Application.application.isVirtualAgent", $bind(Application.application, Application.prototype.isVirtualAgent));
    com.inq.utils.Util.publish("Application.application.setOpeners", $bind(Application.application, Application.prototype.setOpeners));
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.actionMinimize", com.inq.flash.client.control.MinimizeManager.actionMinimize);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.actionRestore", com.inq.flash.client.control.MinimizeManager.actionRestore);
	com.inq.utils.Util.publish("window.inqFrame.com.inq.flash.client.control.MinimizeManager.isMinimized", com.inq.flash.client.control.MinimizeManager.isMinimized);
	com.inq.utils.Util.publish("Application.application.uploadFile", $bind(Application.application, Application.prototype.uploadFile));
    com.inq.utils.Util.publish("com.inq.net.URLLoader", com.inq.net.URLLoader);
    com.inq.utils.Util.publish("com.inq.net.URLRequest", com.inq.net.URLRequest);
    com.inq.utils.Util.publish("com.inq.events.Event.COMPLETE", com.inq.events.Event.COMPLETE);
	com.inq.utils.Util.publish("Application.application.isContinued", $bind(Application.application, Application.prototype.isContinued));

    com.inq.flash.client.control.WebRTCMgr = {
		isEngaged:false
	};

	app.notificationController = {
		showConnectionIssuesMessage:$noop,
		hideNotification:$noop,
		showConnectionRestoredMessage: $noop
	};

	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		window.onunload = function(ev) {
			Application.application.closeChat();
			return true;
		};

		com.inq.flash.client.control.FlashPeer.setPersistentWindowActive(true);
	}

	app[com.inq.utils.Util.configArea] = {};
};

Application.prototype.initializeParameters = function() {
	this.parameters = new com.inq.utils.Dictionary();
	/** @type {string} */
	var flashvarsString = "";
	try {
		flashvarsString = com.inq.flash.client.control.FlashPeer.getFlashVars();

		flashvarsString = flashvarsString.split("socket,").join("");
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERRORS:" + Std.string(e),{ fileName : "Application.hx", lineNumber : 240, className : "Application", methodName : "initializeParameters"});
		} else throw(e);
	}
	var /** @type {Array} */ flashvars = flashvarsString.split("&");
	var /** @type {number} */ _g = 0;
	while(_g < flashvars.length) {
		var /** @type {string} */ fv = flashvars[_g];
		++_g;
		var /** @type {Array} */ namekey = ("" + fv).split("=");
		this.parameters[namekey[0]] = namekey.length == 1?null:decodeURIComponent(namekey[1]);
	}

	com.inq.flash.client.control.FlashVars._init();
};
/**
 * @description not used
 */
Application.prototype.fireMxmlEvent = function() {};

Application.prototype.updateCustomerName = function(customerName) {
	com.inq.flash.client.data.Chat.prototype.setUsername(customerName);
};

Application.prototype.setCustomerName = function(customerName) {
	com.inq.flash.client.control.FlashVars.setCustomerName(customerName, true);
	this.applicationController.updateUsername();
};

Application.prototype.getCustomerName = function() {
	return com.inq.flash.client.control.FlashVars.getCustomerName();
};

Application.prototype.engageChat = function(initialMessage, autoConnect , engageParams, callback) {
	this.applicationController.engage(initialMessage, autoConnect, engageParams, callback );
};

Application.prototype.getChatMessages = function (callback){
	this.applicationController.getChatRouterMessages(callback);
};

Application.prototype.closeChat = function() {
	this.applicationController.closeChat();
};

Application.prototype.sendMessage = function(text) {
	this.applicationController.sendCustomerMessage(text);
};

Application.prototype.sendChatActivity = function(activity) {
    this.applicationController.chatActivity(activity);
};

Application.prototype.requestTranscript = function(email) {
	com.inq.flash.client.control.FlashPeer.requestTranscript(email, com.inq.flash.client.control.FlashVars.getCustomerName());
};

Application.prototype.isVirtualAgent = function () {
	// The "va" value is set from ChatAuthorizedMessageHandler if the chatroom member type is "virtual_agent"
	return com.inq.flash.client.control.PersistenceManager.GetValue(VIRTUAL_AGENT, this.applicationController.chat.getAutomatonId() > 0 ? 1 : 0);
};

Application.prototype.setLiveAgent = function () {
    return com.inq.flash.client.control.PersistenceManager.SetValue(VIRTUAL_AGENT ,1, true, true);
};

Application.prototype.isAgentAssigned = function() {
	if (this.applicationController) {
		return this.applicationController.isAgentAssigned();
	} else {
		return false;
	}
};

Application.prototype.getOpenerScrips = function(event) {
};

Application.prototype.chatUIRendered = function (displayedParams, reBindCallbacks) {
	var customerName = displayedParams["customerName"];
	var disCb = displayedParams["disconnectCb"];
	var reConCb = displayedParams["reConnectCb"];
	var failedCb =  displayedParams["failedCb"];
	var preloadCb = displayedParams["previousMessagesCb"];
	var timeoutCb = displayedParams["timeoutCloseCb"];
	var openers = displayedParams["openerScripts"];
	var agentAlias = displayedParams["defaultAgentAlias"];
	var autoConnectedCb = displayedParams["autoConnectedCb"];

	var skinConfig = com.inq.utils.Util.configArea;
	if (agentAlias) {
		this[skinConfig]["defaultAgentAlias"] = agentAlias;
		this[skinConfig]["useAgentAlias"] = true;
	}
	var that = this;
	if (displayedParams[skinConfig]) {
		Object.keys(displayedParams[skinConfig]).forEach(function (key) {
			that[skinConfig][key] = displayedParams[skinConfig][key];
		});
	}
	this.notificationController.showConnectionIssuesMessage = disCb;
	this.notificationController.showConnectionRestoredMessage = reConCb;
	if (customerName) {
		com.inq.flash.client.control.FlashVars.setCustomerName(customerName, true);
	}
	this.applicationController.onChatShown(preloadCb, failedCb, timeoutCb, autoConnectedCb, reBindCallbacks);

	if (!reBindCallbacks) {
		if (Array.isArray(openers) && openers.length > 0) {
			var agentName = this.applicationController.getAgentAlias();
			openers.forEach(function (msg) {
				Application.application.applicationController.enqueueOpenerText(msg, agentName);
			});
		}
		com.inq.flash.client.control.FlashPeer.onChatShown();
		this.applicationController.initializeAutomatonMode();
	}
};

Application.prototype.setOpeners = function(openers, agentAlias) {
	if(agentAlias) {
		this[com.inq.utils.Util.configArea]["defaultAgentAlias"] = agentAlias;
		this[com.inq.utils.Util.configArea]["useAgentAlias"] = true;
	}
	if(Array.isArray(openers) && openers.length>0) {
		var agentName =  this.applicationController.getAgentAlias();
		openers.forEach(function(msg){
			Application.application.applicationController.enqueueOpenerText(msg,agentName)
		})
	}
};

Application.prototype.sendVALinkClicked = function(event, clickedCb ,linkClickCb, engagedCb) {
	return this.applicationController.sendVALinkClicked(event, clickedCb, linkClickCb, engagedCb);
};

Application.prototype.sendVAMessage = function(msgObj) {
	return this.applicationController.sendVAMessage(msgObj);
};

Application.prototype.getOpeners = function(resCb) {
	return this.applicationController.getOpenerScripts(resCb);
};

Application.prototype.isInProgress = function() {
	return this.applicationController.isChatInProgress();
};
Application.prototype.setFocusOnInputField = function() {};

Application.prototype.setTextFieldfocus = function() {};
Application.prototype.isConversationActive = function() {
	return this.applicationController.skinControl.conversationActive;
};

Application.processConversationTranscriptResponse = function(response, callback) {
	var processResult = false;
	try {
		//true if any messages were inserted into transcript
		com.inq.flash.client.chatskins.SkinControl.parseConversationTranscript(response,callback);
		processResult = true;
	} catch(e) {
		callback([]);
		haxe.Log.trace("Application.processConversationTranscriptResponse " + Std.string(e),
			{
				fileName: "CMSDKApp.js",
				className: "Application",
				methodName: "processConversationTranscriptResponse",
				customParams: ["error"]
			}
		);
	}

	return processResult;
};

Application.prototype.customerEndsCobrowse = function() {
	com.inq.flash.client.chatskins.CoBrowseMgr.endCob();
};

Application.prototype.getButton = function() {
};

/**
 * Api to send rich content widget response to chatrouter
 * @param {String} text
 * @param {Object} data
 * @param {Function} engagedCallback
 */
Application.prototype.sendRichContentResponse = function (text, data, engagedCallback) {
	this.applicationController.sendRichMessage(text, data, engagedCallback);
};

/**
 * Api to check if chat communication handler is connected
 * @param text
 * @param data
 */

Application.prototype.isConnected = function() {
	if (this.applicationController) {
		return this.applicationController.isConnected() && !this.applicationController.isSendMessageFail();
	} else {
		return false;
	}
};

Application.prototype.isAsyncChat = function() {
    return this.applicationController.chat.isAsyncChat();
};

Application.prototype.getAsyncChatMode = function() {
	return com.inq.flash.client.control.FlashVars.getValue("conversationMode") || Application.LAST;
};

Application.prototype.showOpenerForEndedConv = function() {
	return this.applicationController.chat.showOpenerForEndedConversation;
};

Application.prototype.getPersistenceManager = function() {
	return com.inq.flash.client.control.PersistenceManager.__inst;
};

Application.prototype.getPersistedValue = function (key, defaultValue) {
    return com.inq.flash.client.control.PersistenceManager.GetValue(key, defaultValue);
};

Application.prototype.setPersistedValue = function (key, value) {
    com.inq.flash.client.control.PersistenceManager.SetValue(key, value);
};

Application.prototype.removePersistedValue = function (key) {
	com.inq.flash.client.control.PersistenceManager.DeleteValue(key);
};

Application.prototype.setPersistedValues = function (map) {
    com.inq.flash.client.control.PersistenceManager.SetValues(map);
};

Application.prototype.getImagePath = function() {
	if (this.imgpath) {
		return this.imgpath;
	}
	var skinFolderName = com.inq.flash.client.control.FlashPeer.getSkin().split("/").pop().split(".").shift();
	this.imgpath = com.inq.flash.client.control.FlashPeer.getImagePath() + skinFolderName + "/";
	return this.imgpath;
};

Application.prototype.isMinimized = function() {
	return com.inq.flash.client.control.MinimizeManager.isMinimized();
};

Application.prototype.getMinimizedCount = function() {
	return com.inq.flash.client.control.MinimizeManager.count;
};

Application.prototype.resetMinimizedCount = function() {
	return com.inq.flash.client.control.MinimizeManager.reset();
};

Application.prototype.isChatQueued = function() {
	return this.applicationController.isChatInQueue();
};

Application.prototype.isPersistentWindow = function() {
	return com.inq.flash.client.control.FlashPeer.isPersistentWindow();
};


Application.prototype.getDeviceType = function() {
	return com.inq.flash.client.control.FlashPeer.getDeviceType();
};

Application.prototype.getChatParams = function() {
	return this.applicationController.getChat();
};

Application.prototype.setPreventChatClosed = function (value) {
	this.preventChatClose = value;
};

Application.prototype.getPreventChatClosed = function () {
	return this.preventChatClose;
};

Application.prototype.setAsyncLoading = function (state) {
	com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = state;
};

Application.prototype.uploadFile = function (file, statusCallback, engagedCallback) {
	com.inq.flash.client.control.FileUploadHandler.actionUpload(file, statusCallback, engagedCallback);
};

Application.prototype.sendSystemMsg = function (text) {
    this.applicationController.sendSystemMessage(text);
};

Application.prototype.close = function () {
	this.applicationController.close();
};

Application.prototype.isContinued = function () {
	return !!com.inq.flash.client.control.FlashVars.isContinued();
};

/**
 *
 * @type {string}
 */
Application.LAST = "last";
